import { render, staticRenderFns } from "./MemberDetailDialog.vue?vue&type=template&id=67d2c94e&scoped=true"
import script from "./MemberDetailDialog.vue?vue&type=script&lang=ts"
export * from "./MemberDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./MemberDetailDialog.vue?vue&type=style&index=0&id=67d2c94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d2c94e",
  null
  
)

export default component.exports